/* KANAN — reveal-on-scroll, line drawing and number counters for designed pages */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var targets = Array.prototype.slice.call(document.querySelectorAll('[data-knp]'));
  function count(el) {
    var end = parseFloat(el.getAttribute('data-count'));
    if (isNaN(end)) return;
    if (reduce) { el.textContent = end; return; }
    var t0 = Date.now(), dur = 1400;
    el.textContent = '0';
    var timer = setInterval(function () {
      var p = Math.min((Date.now() - t0) / dur, 1);
      el.textContent = Math.round(end * (1 - Math.pow(1 - p, 3)));
      if (p >= 1) clearInterval(timer);
    }, 30);
  }
  function show(sec) {
    if (sec.classList.contains('is-in')) return;
    sec.classList.add('is-in');
    sec.querySelectorAll('[data-count]').forEach(count);
  }
  if (reduce) { targets.forEach(show); return; }
  /* Scroll-position check: works everywhere, including in-app browsers that throttle IntersectionObserver */
  function check() {
    var h = window.innerHeight || document.documentElement.clientHeight;
    targets.forEach(function (t) {
      if (t.classList.contains('is-in')) return;
      var r = t.getBoundingClientRect();
      if (r.top < h * 0.92 && r.bottom > 0) show(t);
    });
  }
  var pending = false;
  function onScroll() {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; check(); }, 60);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { show(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
    targets.forEach(function (t) { io.observe(t); });
  }
  check();
  setTimeout(check, 400);
})();
